export const hotelRoomTypes = [
  "Standard Double",
  "Standard Twin",
  "Standard Triple",
  "Deluxe Double",
  "Deluxe Twin",
  "Deluxe Triple",
  "Single Room",
  "Twin Room",
  "Double Room",
  "Triple Room",
  "Attic Room",
  "Connecting Room",
  "Family Room",
  "Honeymoon Suite",
  "Executive Suite",
  "Suite",
  "Studio",
  "Other",
];

export const activityVehicleTypes = [
  "Sedan",
  "SUV",
  "MUV",
  "Hatchback",
  "Van",
  "Traveller"
]

export const activityCategories = [
  { key: "all", label: "All Categories", icon: "All" },
  { key: "Attractions", label: "Attractions", icon: "Attractions" },
  { key: "Transfers", label: "Transfers", icon: "Transfers" },
  { key: "Tours", label: "Tours", icon: "Tours" },
]

export const leadStatusMap = {
  new: "New Query",
  "in-progress": "In Progress",
  "on-hold": "On Hold",
  confirmed: "Confirmed",
  ongoing: "Ongoing Trip",
  completed: "Trip Completed",
  cancelled: "Cancelled",
};

export const leadFields = [
  {
    label: "Guest Name",
    name: "guestName",
    type: "text",
  },
  {
    label: "Guest Email",
    name: "guestEmail",
    type: "email",
  },
  {
    label: "Guest Mobile",
    name: "guestMobile",
    type: "phone",
  },
  {
    label: "Guest Location",
    name: "guestLocation",
    type: "text",
  },
  {
    label: "Destinations",
    name: "destinations",
    type: "text",
  },
  {
    label: "Nights",
    name: "nights",
    type: "number",
  },
  {
    label: "Adults",
    name: "adults",
    type: "number",
  },
  {
    label: "CWB",
    name: "cwb",
    type: "number",
  },
  {
    label: "CNB",
    name: "cnb",
    type: "number",
  },
  {
    label: "Infants",
    name: "infant",
    type: "number",
  },
  {
    label: "Departure City",
    name: "departureCity",
    type: "text",
  },
  {
    label: "Planned Travel Date",
    name: "plannedTravelDate",
    type: "date",
  },
];
